import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

import { TimetableListFiltersComponent as FiltersComponent } from './timetable-list-filters/timetable-list-filters.component';

@Component({
	selector: 'app-timetable-list',
	templateUrl: './timetable-list.component.html',
	styleUrls: ['./timetable-list.component.css'],
})
export class TimetableListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 2;
	protected apiUrl = 'tourismTimetable';
	data: Array<any> = [];
	parameters = {
		users: [],
		side: [
			{ id: 'departure', name: 'Wyjazd' },
			{ id: 'return', name: 'Powrót' },
		],
	};
	filters = {};
	tableRows = [
		{ id: 'created', name: 'Utworzono' },
		{ id: 'username', name: 'Przez' },
		{ id: 'accommodationFrom', name: 'Zakwaterowanie' },
		{ id: 'season', name: 'Kierunek' },
		{ id: 'sideName', name: 'Strona' },
	];

	protected loadBefore() {
		this.api.get('/users/', (result, error) => {
			this.parameters.users = result.data;
		});
		this.loadData();
	}

	protected convertData(data) {
		data.forEach((obj) => {
			obj.season = [];
			obj.seasons.forEach((season) => {
				obj.season.push(season.destinationName);
			});
			obj.season = obj.season.join(', ');
			obj.departureDate = obj.seasons[0]?.departureDate;
			obj.accommodationFrom = obj.seasons[0]?.accommodationFrom;
			const side = this.parameters.side.find((objFind) => objFind.id == obj.side);
			obj.sideName = side ? side.name : '?';
		});
		return data;
	}
}
